import React, { useState, useEffect, useRef } from 'react'
import { Table, Select, Spin, message } from 'antd';
import axios from 'axios';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import { TfiReload } from "react-icons/tfi";

const OrderHistoryFuture = (props) => {

  const { username, option , newOption } = props?.data
  const [historyData, setHistoryData] = useState([])
  const [showOptions, setShowOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [option2 , setOption2] = useState(option)
  const [Api, setApi] = useState(option[0]?.label)


  useEffect(() => {
    setHistoryData([])
      setOption2(option)
      const fisrtLabel = option[0]?.label
      setApi(fisrtLabel)
  },[option])

  const symbol = ['ADA', 'BNB', 'BTC', 'DOGE', 'ETH', 'GALA', 'MANA', 'OCEAN', 'SOL', 'XRP']
  const [selectedSymbols, setSelectedSymbols] = useState(symbol);

  const dataSource = [];

  if (historyData) {
    for (let i = 0; i < historyData.length; i++) {
      dataSource.push({
        Avg_Price: <p className=' text-center'>{historyData[i]?.Avg_Price}</p>,
        // Close_Position: <p className=' text-center'>{historyData[i]?.Close_Position}</p> ,
        Executed_Qty: <p className=' text-center'>{historyData[i]?.Executed_Qty}</p>,
        Orig_Qty: <p className=' text-center'>{historyData[i]?.Orig_Qty}</p>,
        Orig_Type: <p className=' text-center'>{historyData[i]?.Orig_Type}</p>,
        Position_Side: <p className=' text-center'>{historyData[i]?.Position_Side}</p>,
        // Price: <p className=' text-center'>{historyData[i]?.Price}</p>,
        Side: <p className={`text-center ${historyData[i]?.Side == "BUY" ? ' text-green-500' : 'text-red-500'}`}>{historyData[i]?.Side}</p>,
        Status: <p className={`text-center ${historyData[i]?.Status == "FILLED" ? ' text-green-500' : 'text-red-500'}`}> {historyData[i]?.Status}</p>,
        Stop_Price: <p className=' text-center'>{historyData[i]?.Stop_Price}</p>,
        Symbol: <p className=' text-center'>{historyData[i]?.Symbol}</p>,
        Time: <p className=' text-center'>{historyData[i]?.Time}</p>,
      })
    }
  }


  const columns = [
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>DateTime</p>,
      dataIndex: 'Time',
      key: 'Time',
      width: 200
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Symbol</p>,
      dataIndex: 'Symbol',
      key: 'Symbol',
    },

    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Type</p>,
      dataIndex: 'Orig_Type',
      key: 'Orig_Type',
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Side</p>,
      dataIndex: 'Side',
      key: 'Side',
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Average</p>,
      dataIndex: 'Avg_Price',
      key: 'Avg_Price',
    },
    // {
    //   title: <p className='p-1 text-center rounded-lg table-cell'>Price</p>,
    //   dataIndex: 'Price',
    //   key: 'Price',
    // },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Executed Qty</p>,
      dataIndex: 'Executed_Qty',
      key: 'Executed_Qty',
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Orig Qty</p>,
      dataIndex: 'Orig_Qty',
      key: 'Orig_Qty',
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Position Side</p>,
      dataIndex: 'Position_Side',
      key: 'Position_Side',
    },
    {
      title: <p className='p-1 text-center rounded-lg table-cell'>Status</p>,
      dataIndex: 'Status',
      key: 'Status',
    },
    // {
    //   title: <p className='p-1 text-center rounded-lg table-cell'>Stop Price</p>,
    //   dataIndex: 'Stop_Price',
    //   key: 'Stop_Price',
    // },
  ]

  const handleChange = (value) => {
    setApi(value)
  }

  const orderHistory = () => {
    setShowOptions(false)
    setHistoryData()
    setLoading(true)
    const token = localStorage.getItem('token')
    const postData = {
      jwt: token,
      username: username,
      api_name: newOption,
      symbol: ["ADA", "BNB", "BTC", "DOGE", "ETH", "GALA", "MANA", "OCEAN", "SOL", "XRP"]
    }

    const response = axios({
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      url: process.env.REACT_APP_API + "order_history_futures",
      data: postData
    }).then(res => {
      const resposneData = res.data.Success
      const formattedData = resposneData.map(item => ({
        ...item,
        Time: new Date(item?.Time).toLocaleDateString('en-GB') + ' ' + new Date(1701540808180).toLocaleTimeString()
      }))
      setHistoryData(formattedData)
      setLoading(false)
    }).catch(err => {
      setLoading(false)
      // message.error(err?.response?.data?.Error)
    })
  }

  useEffect(() => {
    orderHistory()
  }, [newOption, selectedSymbols])
  // useEffect(() => {
  //   if(Api){
  //     orderHistory()
  //   }
  // }, [Api, selectedSymbols])

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSymbolFilter = (symbol) => {
    const updatedSelectedSymbols = [...selectedSymbols];

    if (updatedSelectedSymbols.includes(symbol)) {
      updatedSelectedSymbols.splice(updatedSelectedSymbols.indexOf(symbol), 1);
    } else {
      updatedSelectedSymbols.push(symbol);
    }
    setSelectedSymbols(updatedSelectedSymbols);
  };

  return (
    <div>
      <div className=' flex gap-4 mb-4'>

        {/* <div>
          <span className=' text-base font-semibold'>API Name : </span>
          <Select
            value={Api}
            className='focus:border-colorAccent hover:border-colorAccent'
            style={{
              width: 180,
            }}
            placeholder="Select API Name"
            onChange={handleChange}
            options={option2}
          />
        </div> */}

        {/* <div ref={dropdownRef} className="flex flex-col items-center  lg:space-x-4 ">
          <div className="">
            <div className=' flex gap-2 items-center'>
              <span className='text-base font-semibold'>Symbols :</span>
              <div className="relative">
                <button
                  id="selectedOption"
                  onClick={() => setShowOptions(!showOptions)}
                  className="text-left flex justify-between items-center px-3 bg-white text-[#d0d0d0] border-[#d9d9d9] border w-[200px] text-sm   py-[5px] rounded-md"
                >
                  Select Symbols <span className=' text-xl'>{showOptions ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}</span>
                </button>

                {showOptions && (
                  <div className="mt-2 absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md z-40">
                    {symbol?.map((option, index) => (
                      <div key={index}>
                        <label className="block px-2 py-1 text-sm">
                          <input
                            type="checkbox"
                            onChange={() => handleSymbolFilter(option)}
                            checked={selectedSymbols.includes(option)}
                            className="mr-2"
                          />
                          {option}
                        </label>
                      </div>
                    ))}
                    <button onClick={orderHistory} className=' block mx-auto menu-item font-semibold rounded-2xl mb-4 bg-colorAccent py-2 top-left-shadow w-[50%]'>submit</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <div className='my-3 flex flex-col md:flex-row md:items-center gap-2 px-2'>
        <p>Data may be displayed with a delay of 1-2 minutes, please click Refresh to update the data </p>
        <button className=' flex items-center gap-2  text-colorSecondaryDark font-medium' onClick={orderHistory}><TfiReload className='  ' /> Refresh</button>
      </div>

      <div>
        <Spin spinning={loading} >
          <Table columns={columns} dataSource={dataSource}  scroll={{
            x: 1500,
          }} />
        </Spin>

      </div>
    </div>
  )
}

export default OrderHistoryFuture
